import { CEFR_LEVELS } from '@repo/config';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const grammarCoverageLevelSchema = z.object({
  level: z.enum(CEFR_LEVELS),
  approved: z.number().int().min(0),
  draft: z.number().int().min(0),
  total: z.number().int().min(0),
});

const getGrammarCoverageV1DataSchemaDefinition = z.object({
  levels: z.array(grammarCoverageLevelSchema),
  mining: z.object({
    zeroClips: z.number().int().min(0),
    oneClip: z.number().int().min(0),
    twoClips: z.number().int().min(0),
    threePlusClips: z.number().int().min(0),
    pendingTriage: z.number().int().min(0),
    unminedSubtitles: z.number().int().min(0),
  }),
});

export const getGrammarCoverageV1DataSchema: typeof getGrammarCoverageV1DataSchemaDefinition =
  getGrammarCoverageV1DataSchemaDefinition;

export type IGetGrammarCoverageV1Data = z.infer<typeof getGrammarCoverageV1DataSchema>;

export const getGrammarCoverageV1ResponseSchema: z.ZodSchema<IAPI<IGetGrammarCoverageV1Data>> =
  createApiResponseSchema(getGrammarCoverageV1DataSchema) as z.ZodSchema<
    IAPI<IGetGrammarCoverageV1Data>
  >;

export type IGetGrammarCoverageV1Response = IAPI<IGetGrammarCoverageV1Data>;
